import React from "react";
import {
    BrowserRouter, Route, Routes
} from "react-router-dom";
import Accounts from "./pages/accounts";
import AddBankAccount from "./pages/add-bank-acc";
import AddDebitCard from "./pages/add-debit-card";
import BuySell from "./pages/buy-sell";
import Demo from "./pages/demo";
import History from "./pages/history";
import Dashboard from "./pages/index";
import Landing from "./pages/landing";
import Locked from "./pages/lock";
import Otp1 from "./pages/otp-1";
import Otp2 from "./pages/otp-2";
import PrivacyPolicy from "./pages/privacy-policy";
import Reset from "./pages/reset";
import Settings from "./pages/settings";
import SettingsAccount from "./pages/settings-account";
import Preferences from "./pages/settings-preferences";
import SettingsSecurity from "./pages/settings-security";
import Signin from "./pages/signin";
import Signup from "./pages/signup";
import TermsCondition from "./pages/terms-condition";
import VerifyStep1 from "./pages/verify-step-1";
import VerifyStep2 from "./pages/verify-step-2";
import VerifyStep3 from "./pages/verify-step-3";
import VerifyStep4 from "./pages/verify-step-4";
import VerifyStep5 from "./pages/verify-step-5";
import VerifyStep6 from "./pages/verify-step-6";
function Index() {
    return (
        <>
            <BrowserRouter>
                {/* <BrowserRouter basename="/treemium-react/"> */}
                <div id="main-wrapper">
                    <Routes>
                        <Route path="/" exact element={<Dashboard />} />
                        <Route path="/buy-sell" element={<BuySell />} />
                        <Route path="/accounts" element={<Accounts />} />
                        <Route path="/settings" element={<Settings />} />
                        <Route
                            path="/settings-preferences"
                            element={<Preferences />}
                        />
                        <Route
                            path="/settings-security"
                            element={<SettingsSecurity />}
                        />
                        <Route
                            path="/settings-account"
                            element={<SettingsAccount />}
                        />
                        <Route
                            path="/add-bank-acc"
                            element={<AddBankAccount />}
                        />
                        <Route
                            path="/add-debit-card"
                            element={<AddDebitCard />}
                        />
                        <Route path="/lock" element={<Locked />} />
                        <Route path="/otp-1" element={<Otp1 />} />
                        <Route path="/otp-2" element={<Otp2 />} />
                        <Route
                            path="/privacy-policy"
                            element={<PrivacyPolicy />}
                        />
                        <Route path="/reset" element={<Reset />} />
                        <Route path="/signin" element={<Signin />} />
                        <Route path="/signup" element={<Signup />} />
                        <Route
                            path="/terms-condition"
                            element={<TermsCondition />}
                        />
                        <Route
                            path="/verify-step-1"
                            element={<VerifyStep1 />}
                        />
                        <Route
                            path="/verify-step-2"
                            element={<VerifyStep2 />}
                        />
                        <Route
                            path="/verify-step-3"
                            element={<VerifyStep3 />}
                        />
                        <Route
                            path="/verify-step-4"
                            element={<VerifyStep4 />}
                        />
                        <Route
                            path="/verify-step-5"
                            element={<VerifyStep5 />}
                        />
                        <Route
                            path="/verify-step-6"
                            element={<VerifyStep6 />}
                        />
                        <Route path="/history" element={<History />} />
                        <Route path="/demo" element={<Demo />} />
                        <Route path="/landing" element={<Landing />} />
                    </Routes>
                </div>
            </BrowserRouter>
        </>
    );
}

export default Index;
